export default __webpack_public_path__ + "alberta-document-info.1ad2f7261e91a255e8df.svg";